AjaxQueue = require 'network/ajax-queue'
Auth = require 'db/auth'
Controller = require 'controller'
Util = require 'lib/util'
Promise = require 'bluebird'
Queue = require 'promise-queue'
f = require 'effing'
xtend = require 'xtend'

queue = new Queue(3)

methodOf = (opts) ->
  (opts.type ? opts.method ? 'GET').toUpperCase()

performAjax = (opts) ->
  opts.data ?= {}

  # The API requires two forms of authentication (cookie + body) for non-GET
  # requests (to mitigate CSRF attacks), but does not require them for GETs.
  if methodOf(opts) != 'GET'
    opts.data.token = Auth.myToken()

  # But it always expects invitationTokens to be there. This is expected to
  # change in the future, so that this is consistent with token. When that
  # happens, you know what to do.
  opts.data.invitationTokens ?= Util.invitationTokens().join(',')

  # If it is flagged as a background operation that the user did not start,
  # then we do not want to warn about slow sending or break on possible
  # failures.
  if opts.background
    AjaxQueue.send(opts)
    return

  opts.modelCache ?= Controller.getCurrentModelCache()
  AjaxQueue.ajax(opts)
  return

module.exports = (opts, next) ->
  queue.add ->
    success = opts.success ? ->
    error = opts.error ? ->

    new Promise (resolve, reject) ->
      opts = xtend opts,
        success: (args...) ->
          success(args...)
          resolve(args)
          return
        error: (args...) ->
          error(args...)
          reject(args)
          return
      performAjax(opts)
      return
  .nodeify(next).catch(->).done()



// WEBPACK FOOTER //
// ./app/scripts/network/api-ajax.coffee